import React, { Component } from "react";
import { Link } from 'react-router-dom';

class EthicsOfficer extends Component {
  render() {
    return (
    <div>
      <section className="breadcrumbs">
          <div className="container">
            <div className="row">
              <div className="col-sm-6 a-breadcrumbs" style={{color: '#ffffff'}}>
                <Link to="/home" className="a-breadcrumbs">หน้าแรก</Link>&nbsp;
                <i className="fa fa-angle-right" />&nbsp;<a href="#" className="a-breadcrumbs">รู้จักสหกรณ์</a>&nbsp;
                <i className="fa fa-angle-right" />&nbsp;<a href="ethicsofficer" className="a-breadcrumbs">จรรยาบรรณ 10 ประการ สำหรับเจ้าหน้าที่สหกรณ์</a>
              </div>
            </div>
          </div>
        </section>
        <section className="page-section">
          <div className="container">
            <div className="row">
              <div class="col-md-11 col-sm-11 mb-sm-50">
                <h2 className="title-section mt-0 mb-0"><span>จรรยาบรรณ 10 ประการ สำหรับเจ้าหน้าที่สหกรณ์</span></h2><br/>
                <div>
                  <div className="divider gray left mt-20 mb-30" />
                  <p className="mb-30" style={{fontSize: 20}}>
                    1.   พึงปฏิบัติตามนโยบาย ข้อบังคับ ระเบียบของสหกรณ์และคำสั่งของผู้บังคับบัญชาอย่างเคร่งครัด ภายใต้อุดมการณ์ หลักการ และวิธีการสหกรณ์ <br />
                    2.   พึงให้บริการแก่สมาชิกและผู้ใช้บริการด้วยความเต็มใจและประทับใจ<br />
                    3.   พึงรักษาข้อมูลส่วนตัวของสมาชิกเป็นความลับ และไม่นำไปแสวงหาประโยชน์เพื่อตนและพวกพ้อง<br />
                    4.   ให้บริการแก่สมาชิกอย่างเท่าเทียมกัน และไม่เลือกปฏิบัติต่อผู้ใดผู้หนึ่งเป็นการเฉพาะ<br />
                    5.   พัฒนาตนเองให้มีความรู้ความสามารถ เพื่อพัฒนาประสิทธิภาพในการปฏิบัติงาน<br />
                    6.   พึงรักษาและใช้ประโยชน์จากทรัพย์สิน อุปกรณ์ของสหกรณ์อย่างประหยัด คุ้มค่ามากที่สุด รวมถึงไม่นำเอาไปใช้เป็นประโยชน์ส่วนตน<br />
                    7.   พึงรักษาและเสริมสร้างความสามัคคีระหว่างเจ้าหน้าที่สหกรณ์ และหลีกเลี่ยงการสร้างความขัดแย้งปัญหาหรือการกระทำอันเป็นการสร้างความแตกแยก<br />
                    8.   พึงให้ข่าวสารการดำเนินงานสหกรณ์ที่เป็นประโยชน์แก่สมาชิกในทุกโอกาสที่เอื้ออำนวยขณะเดียวกันก็รับฟังปัญหาความต้องการของสมาชิกเพื่อพัฒนาการดำเนินงานในโอกาสต่อไป<br />
                    9.   พึงละเว้นการรับทรัพย์สิน ประโยชน์อื่นใดจากสมาชิก หรือบุคคลภายนอกเพื่อแสวงหาประโยชน์ส่วนตนหรือพวกพ้องอย่างมีศักดิ์ศรี<br />
                    10. หลีกเลี่ยงการทำธุรกิจที่มีผลประโยชน์ทับซ้อน เป็นคู่แข่งขัน หรือเป็นปฏิปักษ์กับสหกรณ์
                  </p>
                </div>
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
              </div>
            </div>
          </div>
        </section>

      </div>
      );
  }
}

export default EthicsOfficer;
